import { Button, Container, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import Page from 'src/components/Page';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  }
}));
// const cordova = require('cordova-plugin-zbtprinter');

function Overview() {
  const classes = useStyles();
  const [name,  setName] = React.useState('');
  const [url,  setURL] = React.useState('');

  const open = () => {
    window.open(url);
  }

  const btAc = () => {
    var YazdirStr = '^XA';
    YazdirStr += '^FX Top section with logo, name and address.';
    YazdirStr += '^CF0,60';
    YazdirStr += '^FO50,50^GB100,100,100^FS';
    YazdirStr += '^FO75,75^FR^GB100,100,100^FS';
    YazdirStr += '^FO93,93^GB40,40,40^FS';
    YazdirStr += '^FO220,50^FDIntershipping, Inc.^FS';
    YazdirStr += '^CF0,30';
    YazdirStr += '^FO220,115^FD1000 Shipping Lane^FS';
    YazdirStr += '^FO220,155^FDShelbyville TN 38102^FS';
    YazdirStr += '^FO220,195^FDUnited States (USAserdar)^FS';
    YazdirStr += '^FO50,250^GB700,1,3^FS';    
    YazdirStr += '^FX Second section with recipient address and permit information.';
    YazdirStr += '^CFA,30';
    YazdirStr += '^FO50,300^FDJohn Doe^FS';
    YazdirStr += '^FO50,340^FD100 Main Street^FS';
    YazdirStr += '^FO50,380^FDSpringfield TN 39021^FS';
    YazdirStr += '^FO50,420^FDUnited States (USA)^FS';
    YazdirStr += '^CFA,15';
    YazdirStr += '^FO600,300^GB150,150,3^FS';
    YazdirStr += '^FO638,340^FDPermit^FS';
    YazdirStr += '^FO638,390^FD123456^FS';
    YazdirStr += '^FO50,500^GB700,1,3^FS';   
    YazdirStr += '^FX Third section with barcode.';
    YazdirStr += '^BY5,2,270';
    YazdirStr += '^FO100,550^BC^FD12345678^FS';    
    YazdirStr += '^FX Fourth section (the two boxes on the bottom).';
    YazdirStr += '^FO50,900^GB700,250,3^FS';
    YazdirStr += '^FO400,900^GB1,250,3^FS';
    YazdirStr += '^CF0,40';
    YazdirStr += '^FO100,960^FDCtr. X34B-1^FS';
    YazdirStr += '^FO100,1010^FDREF1 F00B47^FS';
    YazdirStr += '^FO100,1060^FDREF2 BL4H8^FS';
    YazdirStr += '^CF0,190';
    YazdirStr += '^FO470,955^FDCA^FS';    
    YazdirStr += '^XZ';
    const element = document.createElement("a");
    const file = new Blob([YazdirStr]);
    element.href = URL.createObjectURL(file);
    element.download = name + ".zpl";
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
    return;
  }
  return (
    <Page className={classes.root} title="Yazıcı Test">
      <Container maxWidth="lg">
        <Button
          variant="contained"
          color="secondary"
          onClick={btAc}
        >
          Yazıcı Çıktı Test İçin Kullanılacak yazdır
        </Button>
        <br />
        <br />
        <TextField 
        label="Filename"
        onChange={e => setName(e.target.value)}
        value={name}
        />
        <br />
        <TextField 
        label="URL"
        onChange={e => setURL(e.target.value)}
        value={url}
        />
        <br />
        <Button
          variant="contained"
          color="secondary"
          onClick={open}
        >
          Window Open
        </Button>
      </Container>
    </Page>
  );
}

export default Overview;
